// eslint-disable-next-line import/prefer-default-export
export const BASE_PATH = '/admin/rest';
